import React from 'react';
import {Box, Grid, Typography} from "@mui/material";
import {OperacionCapitalMarketsDetalleFields} from "../types/fields";
import {OperacionCapitalMarketsDetalle} from "../types/types";
import Divider from "@mui/material/Divider";
import {dateFormatter} from "../../../../../utils/formatters";

interface CapitalMarketsDetalleProps {
  detalle: OperacionCapitalMarketsDetalle
}

function CapitalMarketsDetalle({detalle}: CapitalMarketsDetalleProps) {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Emisor</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Emisor]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Valor Nominal</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.ValorNominal]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant={'body2'}>Transacción</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Transaccion]}
          </Typography>
        </Grid>
        {
          detalle[OperacionCapitalMarketsDetalleFields.Transaccion] === 'Lending' &&

            <Grid item container xs={12}>
                <Grid item xs={12}>
                    <Divider style={{width: '100%'}}>
                        <Typography variant='caption'>Datos Transacción Lending</Typography>
                    </Divider>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Deudor</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingDeudor] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Acreedor</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingAcreedor] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Monto</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingMonto] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Moneda</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingMoneda] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Destino de fondos</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingDestino] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Período de disponibilidad</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingPlazoDisponibilidad] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Plazo</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingPlazo] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Amortización</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingAmortizacion] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Tasa de interés</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingTasaInteres] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Frecuencia de pago de interés</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingFrecuenciaInteres] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Garantías</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingGarantias] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Comisión</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingComision] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Pre cancelación</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingPrecancelacion] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Covenants</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingCovenants] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant={'body2'}>Ley y jurisdicción</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingLey] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={'body2'}>Fecha de Ejecución</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingFechaEjecucion] ? dateFormatter.toShortDate(detalle[OperacionCapitalMarketsDetalleFields.LendingFechaEjecucion]) : '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant={'body2'}>Otros</Typography>
                    <Typography variant='body1'>
                      {detalle[OperacionCapitalMarketsDetalleFields.LendingOtros] || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Divider style={{width: '100%'}}/>
                </Grid>

            </Grid>
        }
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Moneda</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Moneda]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Plazo</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Plazo]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Amortización</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Amortizacion]}
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Colocadores</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Colocadores]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Rating</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Rating]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Destino de Fondos</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.DestinoDeFondos]}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Underwriting</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Underwriting]}
          </Typography>
        </Grid>

        <Grid item xs={12} md={4}>
          <Typography variant='body2'>Bridge</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Bridge]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>FEE</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.FEE]}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='body2'>Nota</Typography>
          <Typography variant='body1'>
            {detalle[OperacionCapitalMarketsDetalleFields.Nota]}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default CapitalMarketsDetalle;